import { render, staticRenderFns } from "./MalzemeIslemleri.vue?vue&type=template&id=23a5f6f2&scoped=true&"
import script from "./MalzemeIslemleri.vue?vue&type=script&lang=js&"
export * from "./MalzemeIslemleri.vue?vue&type=script&lang=js&"
import style0 from "./MalzemeIslemleri.vue?vue&type=style&index=0&id=23a5f6f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a5f6f2",
  null
  
)

export default component.exports